import { Controller } from "@hotwired/stimulus"

// Native dialog owns Escape, focus containment and return to the opener.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
  }

  disconnect() {
    this.close()
  }
}
